import { render, staticRenderFns } from "./check-password.vue?vue&type=template&id=6080c01a&scoped=true&"
import script from "./check-password.vue?vue&type=script&lang=js&"
export * from "./check-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6080c01a",
  null
  
)

export default component.exports